import { Inject, Pipe, PipeTransform } from '@angular/core';
import { BASE_DLCS_URL } from 'src/app/injection-tokens';

@Pipe({
  name: 'verkooporderContentLink',
})
export class VerkooporderContentLinkPipe implements PipeTransform {
  constructor(
    @Inject(BASE_DLCS_URL)
    private readonly baseDLCSUrl: string
  ) {}

  transform(fullContentPath: string): string {
    const baseUrl = this.baseDLCSUrl + (this.baseDLCSUrl.endsWith('/') ? '' : '/');
    return `${baseUrl}${fullContentPath}`;
  }
}
